module.exports = __webpack_public_path__ + "static/media/It Makes Sense.31398630.jpg";